import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=3a4bc264&scoped=true&"
import script from "./Wait.vue?vue&type=script&lang=js&"
export * from "./Wait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4bc264",
  null
  
)

export default component.exports